__webpack_require__.p = "https://cdn.brandwatch.com/shared-dashboard-wrapper/1445ba0e22fafa8fd7ff3b72b7ca9822d0a98b42/";